// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N_ZY","input":"styles_input__1F4eR"};